<template>
  <v-app :style="`font-family: ${appFont} !important`">
    <v-navigation-drawer
      class="custom-nav-drawer"
      color="appBarBgColor"
      :mini-variant.sync="drawerMini"
      v-if="authenticated"
      v-model="drawer"
      :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm"
      floating
      left
      app
      clipped
    >
        <v-list nav class="pt-6 pt-md-0 mt-6 mt-md-0">
          <template
            v-for="item in validMenuItems"
          >

            <v-list-group
              v-if="item.children.length > 1 && item.key != 'ai_workforce'"
              :key="item.title"
              v-model="item.active"
              :group="item.path"
              active-class="active-nav-group"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon v-if="item.active" v-text="item.icon_outline"></v-icon>
                  <v-icon v-else v-text="item.icon"></v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-text="$t(item.title)"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="child in item.children"
                :key="child.application_instance_id"
                :to="getAppInstanceHref(item, child)"
                :class="isActiveSubMenuItem(item, child) ? 'v-list-item--active active-nav-item' : ''"
                :exact="item.key == 'home'"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="child.application_instance_title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else-if="item.key != 'home'"
              :key="item.title"
              v-model="item.active"
              :to="getAppInstanceHref(item, item.children[0])"
              :class="isActiveSubMenuItem(item, item.children[0]) ? 'v-list-item--active active-nav-item' : ''"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="$t(item.title)"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </template>
        </v-list>

        <v-spacer></v-spacer>

        <template v-slot:append>
          <v-list nav>
            <v-list-item
              v-if="privilegedUser() == true"
              to="/settings"
              active-class="active-nav-item"
              ref="settings"
            >
              <v-list-item-icon>
                <v-icon>{{settingsIcon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="$t('settings')"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div class="mb-2 hidden-sm-and-down">

            <v-divider light class="divider mb-2"></v-divider>

            <v-btn
              class="mr-2 mb-2 d-flex float-right"
              @click="drawerMini = !drawerMini"
              icon
            >
              <v-icon
                color="appBarTxtColor"
                v-if="!drawerMini"
              >
                mdi-arrow-left
              </v-icon>
              <v-icon
                color="appBarTxtColor"
                v-if="drawerMini"
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>

          </div>
        </template>

    </v-navigation-drawer>

    <v-app-bar
      v-if="authenticated"
      app
      color="appBarBgColor"
      dark
      clipped-left
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
      ></v-app-bar-nav-icon>

      <v-toolbar-title
        class="title-img"
      >
        <router-link :to="{name: 'Home'}">
          <v-img
            :src=appLogo
            height="35px"
            width="200px"
            contain
          ></v-img>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div
        class="d-flex"
      >
        <div class="pa-2">
          <BackgroundActionList />
        </div>

        <div class="pa-2">
          <UserAvatarOptions />
        </div>
      </div>

    </v-app-bar>

    <v-snackbar
      :timeout="message.timeout"
      :value="message.open"
      bottom
      style="margin-bottom:20px; z-index: 10003;"
      :color="message.type"
      v-on:input="messageChanged"
    >
      <v-icon v-if="message.type == 'error'">mdi-alert</v-icon>
      <v-icon v-if="message.type == 'info'">mdi-information</v-icon>
      <v-icon v-if="message.type == 'success'">mdi-check-circle</v-icon>

      {{ message.text }}

      <v-spacer></v-spacer>

      <template v-slot:action>
        <v-btn
          color="appBarTxtColor"
          text
          @click="closeAlert()"
        >
          {{ $t('close') }}
        </v-btn>
      </template>

    </v-snackbar>

    <v-main class="main">
      <router-view />
    </v-main>
  </v-app>
</template>

<style>
  .main {
    background-color: var(--v-appBackground-base);
  }

  .title-img {
    padding-left: 10px !important;
  }
</style>

<style lang="scss">
  @import '@/styles/container-width';
  @import '@/styles/font';
</style>

<style lang="scss" scoped>

  .divider {
    width: 100%;
    border-color: var(--v-appBarTxtColor-darken3) !important;
  }

  ::v-deep .custom-nav-drawer .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
  ::v-deep .custom-nav-drawer .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) .v-icon,
  .v-btn__content > i {
    color: var(--v-appBarTxtColor-darken3) !important;
    font-weight: 400;
  }

  ::v-deep .custom-nav-drawer .v-list-item {
    color: var(--v-appBarTxtColor-base);
    font-weight: 500;
  }

</style>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import ThemeActions from "@/store/core/theme/actions-types"
import AppActions from "@/store/app/actions-types"
import AppMutations from "@/store/app/mutations-types"
import BackgroundActions from '@/store/background_actions/actions-types.js'
import EntryActions from '@/store/content/entry/actions-types'

import BackgroundActionList from '@/components/app/BackgroundActionList.vue'
import UserAvatarOptions from '@/components/app/UserAvatarOptions.vue'
import UserRoles from '@/store/core/user/user-roles.js'
import { BgActionEventBus } from '@/bgActionEventBus'

export default {
  name: 'App',

  components: {
    BackgroundActionList,
    UserAvatarOptions,
  },

  created() {
    this.bgActionRoomRegistrationHandler = (room) => {
      this.setBgActionRoom(room)
    }
    this.bgActionRoomReleaseHandler = (room) => {
      this.releaseRegisteredBgActionRoom(room)
    }

    BgActionEventBus.$on('register-room', this.bgActionRoomRegistrationHandler)
    BgActionEventBus.$on('release-room', this.bgActionRoomReleaseHandler)

    window.addEventListener('beforeunload', this.handleBeforeUnload)
    window.addEventListener('pagehide', this.handlePageHide)
    window.addEventListener('unload', this.handleUnload)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('pagehide', this.handlePageHide)
    window.removeEventListener('unload', this.handleUnload)
  },

  computed: {
    ...mapGetters('background_actions', [
      'hasProcessingActions'
    ]),

    ...mapState({
      authenticated: state => state.core.auth.authenticated,
      userData: state => state.core.auth.userData,
      userRoles: state => state.core.auth.userRoles,
      menuItems: state => state.app.menuItems,
      message: state => state.app.message,
      socket: state => state.app.socket
    }),

    validMenuItems() {
      return this.menuItems.filter(mi => mi.children.length > 0)
    },

    appFont() {
      if(this.$vuetify.theme.themes.light.font)
        return this.$vuetify.theme.themes.light.font
      return 'Roboto, sans-serif'

    },

    appLogo() {
      if(this.$vuetify.theme.themes.light.logo)
        return this.$vuetify.theme.themes.light.logo
      return require('@/assets/logo_jamworks.svg')
    }
  },

  data: () => ({
    drawer: true,
    drawerMini: true,
    settingsIcon: "mdi-cog",
    activeItem: 'MasterTenant',
    bgActionTargetRoom: null,
    bgActionSubscribedRoom: null,
    bgActionSocketRoomHandler: null,
    bgActionRoomRegistrationHandler: null,
    bgActionRoomReleaseHandler: null,
    unloadCleanupStarted: false,
  }),

  watch: {
    '$route.params.parentId': {
      handler: function(parentId) {
        this.setBgActionRoom(parentId)
      },
      immediate: true,
    },

    socket(newSocket) {
      if (!newSocket) {
        this.bgActionSubscribedRoom = null
        this.bgActionSocketRoomHandler = null
        return
      }

      this.bgActionSubscribedRoom = null
      this.syncBgActionRoom()
    },

    'authenticated'() {
      if (this.authenticated) {
        this[AppActions.CONNECT_WEBSOCKET]()

        this.syncBgActionRoom()
        this.setUserTheme()
      }

      if (!this.authenticated && this.socket) {
        this[AppActions.DISCONNECT_WEBSOCKET]()
      }
    }
  },

  updated() {
    if(this.$vuetify.breakpoint.smAndDown)
      this.drawerMini = false

    if(this.$refs.settings && this.$refs.settings.$el.classList.contains("v-list-item--active")) {
      this.settingsIcon = "mdi-cog-outline";
    } else {
      this.settingsIcon = "mdi-cog";
    }
  },

  methods: {
    handleBeforeUnload(event) {
      if (this.hasProcessingActions()) {
        event.preventDefault()
        event.returnValue = ''
      }
    },

    handlePageHide(event) {
      // pagehide fires only after the user accepts the native close/reload
      // prompt. Do not cancel uploads when the page enters the back-forward
      // cache because it may be restored without being closed.
      if (event.persisted) {
        return
      }

      this.runUploadUnloadCleanup()
    },

    handleUnload() {
      // Some browsers do not reliably dispatch pagehide on reload. unload is
      // a fallback that runs only after the native beforeunload confirmation.
      this.runUploadUnloadCleanup()
    },

    runUploadUnloadCleanup() {
      // Browsers that dispatch both pagehide and unload must not receive two
      // abort requests for the same upload.
      if (this.unloadCleanupStarted) {
        return
      }

      this.unloadCleanupStarted = true

      this.$store.state.background_actions.list
        .filter(action => action.type === 'upload' && action.status === 'in_progress' && action.unloadCleanup)
        .forEach(({ unloadCleanup }) => {
          this.queueUploadCleanupRefresh(unloadCleanup.refreshMessage)

          fetch(unloadCleanup.url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              token: unloadCleanup.token
            },
            body: unloadCleanup.body,
            keepalive: true
          }).catch(error => console.error('[upload] unload cancellation cleanup failed', error))
        })
    },

    queueUploadCleanupRefresh(message) {
      if (!message) {
        return
      }

      try {
        const storageKey = 'pending-upload-cleanup-bg-actions'
        const pendingMessages = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
        sessionStorage.setItem(storageKey, JSON.stringify([...pendingMessages, message]))
      } catch (error) {
        // Storage can be unavailable in private browsing. The abort request
        // must still be sent even when the UI refresh cannot be queued.
        console.error('[upload] unable to queue cleanup refresh', error)
      }
    },

    ...mapActions('app', [
      AppActions.CONNECT_WEBSOCKET,
      AppActions.DISCONNECT_WEBSOCKET,
      AppActions.SUBSCRIBE_TO_ROOM,
      AppActions.UNSUBSCRIBE_FROM_ROOM,
    ]),

    ...mapActions('background_actions', [
      BackgroundActions.CREATE_OR_UPDATE_BACKGROUND_ACTION
    ]),

    ...mapActions('content/entry', [
      EntryActions.HANDLE_LOCK_MESSAGE,
    ]),

    ...mapActions('core/theme', [
      ThemeActions.GET_USER_SELECTED_THEME
    ]),

    ...mapMutations('app', [
      AppMutations.SET_APP_MESSAGE_OPEN
    ]),

    closeAlert() {
      this[AppMutations.SET_APP_MESSAGE_OPEN](false)
    },

    privilegedUser() {
      for (let i = 0; i < this.userRoles.length; i++) {
        if (this.userRoles[i] != UserRoles.USER_REGULAR) {
          return true;
        }
      }
      return false
    },

    getBgActionUserId(message) {
      return message.users_id ?? message.usersId ?? message.user_id ?? message.userId ?? message.user?.users_id ?? message.user?.id
    },

    getBgActionParentNodeId(message) {
      return message.node_parent
        ?? message.nodeParent
        ?? message.folder_parent_id
        ?? message.folderParentId
    },

    handleBgActionRoomMessage(message, room) {
      const normalizedMessage = this.normalizeBgActionMessage(message, room)

      if (!this.isCurrentBgActionRoomMessage(normalizedMessage)) {
        return
      }

      if (this.isNodeLockBgActionMessage(normalizedMessage)) {
        this[EntryActions.HANDLE_LOCK_MESSAGE](normalizedMessage)
        BgActionEventBus.$emit('bgAction', normalizedMessage)
        return
      }

      if (this.isCompletedBgActionMessage(normalizedMessage) && !this.isCurrentUserBgActionMessage(normalizedMessage)) {
        BgActionEventBus.$emit('bgAction', normalizedMessage)
        return
      }

      if (this.isCurrentUserBgActionMessage(normalizedMessage)) {
        this[BackgroundActions.CREATE_OR_UPDATE_BACKGROUND_ACTION](normalizedMessage)
        return
      }
    },

    normalizeBgActionMessage(message, room) {
      const normalizedMessage = {
        ...message,
        bgActionId: message.bgActionId ?? message.bg_action_id,
        bgGroupId: message.bgGroupId ?? message.bg_group_id,
      }

      if (this.getBgActionParentNodeId(normalizedMessage) === null || this.getBgActionParentNodeId(normalizedMessage) === undefined) {
        normalizedMessage.node_parent = room
      }

      return normalizedMessage
    },

    setBgActionRoom(parentId) {
      this.bgActionTargetRoom = (parentId === null || parentId === undefined) ? null : String(parentId)
      this.syncBgActionRoom()
    },

    releaseRegisteredBgActionRoom(room) {
      const routeParentId = this.$route?.params?.parentId

      if (routeParentId !== null && routeParentId !== undefined) {
        this.setBgActionRoom(routeParentId)
        return
      }

      if (String(this.bgActionTargetRoom) === String(room)) {
        this.setBgActionRoom(null)
      }
    },

    syncBgActionRoom() {
      if (!this.socket) {
        return
      }

      if (this.bgActionSubscribedRoom && this.bgActionSubscribedRoom !== this.bgActionTargetRoom) {
        this.releaseBgActionRoomListener(this.bgActionSubscribedRoom)
        this[AppActions.UNSUBSCRIBE_FROM_ROOM](this.bgActionSubscribedRoom)
        this.bgActionSubscribedRoom = null
      }

      if (this.bgActionTargetRoom !== null && this.bgActionTargetRoom !== undefined && this.bgActionSubscribedRoom !== this.bgActionTargetRoom) {
        this.registerBgActionRoomListener(this.bgActionTargetRoom)
        this[AppActions.SUBSCRIBE_TO_ROOM](this.bgActionTargetRoom)
        this.bgActionSubscribedRoom = this.bgActionTargetRoom
      }
    },

    registerBgActionRoomListener(room) {
      if (!this.socket || room === null || room === undefined) {
        return
      }

      const roomName = String(room)
      this.bgActionSocketRoomHandler = (message) => this.handleBgActionRoomMessage(message, roomName)
      this.socket.on(roomName, this.bgActionSocketRoomHandler)
    },

    releaseBgActionRoomListener(room) {
      if (!this.socket || !this.bgActionSocketRoomHandler || room === null || room === undefined) {
        return
      }

      const roomName = String(room)
      this.socket.off(roomName, this.bgActionSocketRoomHandler)
      this.bgActionSocketRoomHandler = null
    },

    getCurrentBgActionParentNodeId() {
      return this.bgActionTargetRoom
    },

    isCurrentBgActionRoomMessage(message) {
      const messageParentNodeId = this.getBgActionParentNodeId(message)
      const currentParentNodeId = this.getCurrentBgActionParentNodeId()

      if (messageParentNodeId === null || messageParentNodeId === undefined) {
        return false
      }

      if (currentParentNodeId === null || currentParentNodeId === undefined) {
        return false
      }

      return String(messageParentNodeId) === String(currentParentNodeId)
    },

    isCurrentUserBgActionMessage(message) {
      const messageUserId = this.getBgActionUserId(message)

      if (messageUserId === null || messageUserId === undefined) {
        return false
      }

      return String(messageUserId) === String(this.userData.users_id)
    },

    isCompletedBgActionMessage(message) {
      return ['success', 'done', 'error'].includes(String(message.status).toLowerCase())
    },

    isNodeLockBgActionMessage(message) {
      return ['node_lock', 'node-lock'].includes(String(message.type).toLowerCase())
    },

    messageChanged() {
      this[AppMutations.SET_APP_MESSAGE_OPEN](false)
    },

    getAppInstanceHref(menuItem, child) {
      return menuItem.href.replace(/:appId/, child.application_instance_id)
    },

    isActiveSubMenuItem(menuItem, child) {
      let subItemPath = ""

      if (menuItem.key == 'home') {
        subItemPath = this.getAppInstanceHref(menuItem, child)

        return this.$route.fullPath.startsWith(subItemPath)
      }

      subItemPath = `${menuItem.path}/${child.application_instance_id}`

      return this.$route.path.startsWith(subItemPath)
    },

    setUserTheme() {
      this[ThemeActions.GET_USER_SELECTED_THEME](this.userData.users_id)
        .then((theme) => {
          if (! theme) {
            return
          }

          this.$vuetify.theme.themes.light = JSON.parse(theme.theme_config)
        })
    },
  }
};
</script>
